// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"745":"contactDetails","945":"dashboard"}[chunkId] + "." + {"745":"4278c610","945":"f3934650"}[chunkId] + ".css";
};